
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

import { AlignEnum, FeatureIdEnum } from '../../enums'

import { ListAnimationMixin } from '../../mixins'

import { ROUTER_CONSTS } from '../../router/router.consts'

import { StringUtils } from '../../utils'

import Searchbox from '../searchbox.component.vue'
import { EpbButton } from '../shared/epb-button'
import InstanceCard from './instance-card.component.vue'

export default defineComponent({
  name: 'InstancesGrid',
  components: {
    EpbButton,
    InstanceCard,
    Searchbox,
  },
  mixins: [ListAnimationMixin],
  props: {
    instances: {
      type: Array as PropType<Array<Instance>>,
      required: true,
    },
    selectedInstanceId: String,
    instancesShownByDefault: {
      type: Number,
      default: 8,
    },
    columns: {
      type: Number,
      default: 4,
    },
    align: {
      type: String as PropType<AlignEnum>,
      default: AlignEnum.START,
    },
    messages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-instances-grid',
      query: '',
      queryInputTimeout: undefined,
      showAllInstances: false,
      cardMargin: 10,
      ROUTER_CONSTS,
      FeatureIdEnum,
    }
  },
  computed: {
    classes(): [string, Record<string, boolean>] {
      return [
        this.baseClass,
        {
          [`${this.baseClass}--align-start`]: this.align === AlignEnum.START,
          [`${this.baseClass}--align-center`]: this.align === AlignEnum.CENTER,
          [`${this.baseClass}--align-end`]: this.align === AlignEnum.END,
        },
      ]
    },
    visibleInstances(): Instance[] {
      if (this.query) {
        const normalizedQuery = StringUtils.normalize(this.query)
        const stringMatchesQuery = (field: string): boolean =>
          StringUtils.normalize(field).includes(normalizedQuery)
        return this.instances.filter(
          (instance: Instance) =>
            (!!instance.prettyName && stringMatchesQuery(instance.prettyName)) ||
            stringMatchesQuery(instance.id),
        )
      }
      return !this.showAllInstances
        ? this.instances.slice(0, this.instancesShownByDefault)
        : this.instances
    },
    cardStyle() {
      return {
        flexBasis: `calc(100% / ${this.columns} - ${this.cardMargin * 2}px)`,
        margin: `${this.cardMargin}px`,
      }
    },
    showAllInstancesMessage(): string {
      if (!this.showAllInstances) {
        return this.$epb.utils.compileMessage(this.messages.showAll, {
          counter: this.instances.length,
        })
      }
      return this.messages.showLess
    },
  },
  watch: {
    query(): void {
      this.showAllInstances = false
    },
  },
  methods: {
    onQueryInput(query: string): void {
      clearTimeout(this.queryInputTimeout)
      this.queryInputTimeout = setTimeout(() => {
        this.query = query
      }, 300)
    },
  },
})
